/* eslint-disable import/prefer-default-export */

/*
 * Tracks a custom event with Google Analytics.
 */
export function track(category, action, label = "", value = 1, nonInteraction = true) {
  gtag("event", action, {
    event_category: category,
    event_label: label,
    non_interaction: nonInteraction,
    value,
  })
}
